import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineMedium = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="160px"
        height="3px"
        viewBox="0 0 160 3"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M158.3,0.6c-0.2,0-0.4-0.2-0.4-0.2c-0.3,0.1-0.4,0-0.5-0.1c-0.2-0.3-0.8-0.1-1.2-0.2c-0.5,0.4-1,0-1.5,0
            c-0.3,0.1-0.7,0.2-0.9,0.1c-0.7-0.2-1.5-0.1-2.3-0.1c-0.5,0-0.7,0-1.1-0.2c-0.1,0.2-0.2,0.3-0.3,0.6c-0.9-0.4-1.9-0.4-2.9-0.2
            c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0.1-0.4,0.1-0.5,0.2c-0.2,0-0.3,0.1-0.6,0.2c-0.1-0.1-0.2-0.2-0.2-0.2c-0.6,0.1-1.2,0.2-1.6,0.1
            c-0.8-0.1-1.6,0-2.4,0c-0.8,0-1.7,0.2-2.3-0.1c-0.4,0-0.7,0.1-1,0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.2,0.2-0.5,0.3-1,0.2
            c-0.3-0.1-0.7-0.1-1-0.2c-0.5,0-1-0.1-1.2,0.2c-0.4-0.1-0.8-0.2-1.2-0.3c-0.3,0.1-0.4,0.2-0.7,0.4c-0.1-0.1-0.2-0.2-0.3-0.3
            c-0.5,0-0.9,0-0.9,0.2c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0.1-0.7,0c-0.6-0.1-1.1-0.3-1.7,0c0,0-0.2,0-0.2,0c-0.4-0.1-0.9,0-1.3-0.1
            c-0.2,0-0.4-0.1-0.6-0.2c-0.7,0.2-0.7,0.2-2.2,0c0,0.1,0,0.2-0.1,0.3c-1.1-0.1-2.2-0.3-3.3,0c-0.8-0.2-1.8,0.2-2.4-0.2
            c-0.4,0.1-0.7,0.1-1,0.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0.1-0.3,0.2-0.3,0.2c-0.6,0-1.1-0.1-1.6-0.1c-0.5,0-1,0.1-1.5-0.1
            c-0.1,0-0.3-0.1-0.5-0.1c-0.1,0.1-0.1,0.2-0.2,0.4c-0.6-0.1-1.1-0.2-1.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.5,0.2-0.8,0.3
            c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4,0-0.7,0.1-1,0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.4,0.1-0.8,0.2-1.1,0.2c-1.4-0.1-2.8,0-4.1-0.1
            c-0.2,0-0.5,0-0.6,0c-0.9,0.3-1.8,0-2.7,0.1c-0.7-0.4-1,0-1.5,0.2C97,0.2,96.5,0,95.8,0.3c-0.1,0-0.3,0.1-0.4,0
            c-0.7-0.1-1.2,0.1-1.7,0.3c-0.1-0.1-0.3-0.3-0.3-0.3c-0.8,0.1-1.6,0-2.4,0c-1,0-2,0.2-3.1,0.1c-0.6,0.2-1.2,0-1.8-0.1
            c-0.2,0-0.6-0.1-0.6,0c-0.6,0.4-1,0.1-1.5,0C83,0.4,82.9,0.4,82.8,0c-0.3,0.2-0.5,0.3-0.7,0.5c-0.6-0.3-1.5,0.1-2.2-0.3
            c-0.1,0.1-0.3,0.3-0.4,0.4c-0.5-0.2-0.9-0.3-1.4-0.5c-0.8,0.3-1.6,0-2.4,0.1c0,0.1,0,0.1,0,0.2c-0.7,0.1-1.3,0-1.7-0.3
            c-0.5,0.1-0.7,0.4-1.3,0.2c-0.8-0.2-0.8,0.1-1.2,0.3c-0.4-0.2-0.7-0.5-1.4-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.4,0.1-0.7,0.2-1,0.2
            c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2,0.1-0.4,0.2-0.8,0.4c-0.1-0.1-0.3-0.2-0.4-0.4
            c-0.7,0.3-1.5,0.3-2.1,0.2c-1-0.2-1.8-0.1-2.6,0c-0.4,0-0.8,0-1.2-0.1c-0.5-0.1-0.6,0.2-1.1,0.1c-0.2-0.1-0.4-0.2-0.6-0.3
            c-0.4,0.1-0.7,0.2-1,0.4c-0.5-0.1-0.9-0.2-1.4-0.3c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0-0.5,0-0.7,0c-0.3,0-0.6,0-0.8,0
            c-0.5-0.1-1.1-0.2-1.5,0.1c-0.6-0.2-1.4,0.1-2-0.2c-0.2-0.1-0.5-0.1-0.6,0c-0.1,0.2-0.3,0.1-0.6,0.2c-0.2,0-0.3,0.1-0.5,0.2
            c-0.1,0-0.2-0.1-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.8-0.1-1.2-0.1c-0.7,0-1,0.1-1.3,0.4
            c0,0-0.2,0-0.3,0.1c0-0.2,0-0.3,0.1-0.5c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.5,0.1-0.6,0c-0.2-0.1-0.2-0.2-0.4-0.3
            c-0.4,0.1-0.7,0.2-1.1,0.4c-0.3,0-0.8,0-1.2-0.1c-1-0.1-1-0.2-1.5,0.2c-0.3-0.3-1-0.3-1.4-0.2c-0.4,0.1-0.8,0-1.2,0
            c-0.5,0-1.1-0.1-1.6,0c-0.3,0.1-0.6,0-0.9-0.1c-0.5-0.1-0.8-0.1-0.9,0.2c-1.1,0.2-1.9-0.3-2.9-0.3c0.1,0.1,0.2,0.2,0.2,0.3
            c-0.8,0.1-1.2-0.1-1.5-0.3c-0.5,0.2-0.7,0.2-1.4,0.1c-0.1,0-0.2,0-0.3,0c-0.4,0.2-0.8,0.1-1.2,0c-0.2-0.1-0.7,0-0.7,0
            c-0.1,0.2-0.7,0.1-0.8,0.1c-0.5,0.3-0.7-0.1-1.2,0c-0.4,0.1-0.8,0.2-1.3,0c-0.3-0.1-1,0-1.4,0c-0.6,0.1-1-0.1-1.6-0.2
            c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4-0.1-0.7-0.2-1-0.3c-0.4,0.4-1,0.3-1.7,0.2c-0.3-0.1-0.6-0.1-1-0.1c0.1,0.1,0.2,0.2,0.3,0.4
            c-0.5,0-1,0-1.2-0.1c-0.5-0.3-0.9-0.2-1.5,0c-0.5,0.1-1.3,0.1-1.9,0.1c-0.3,0-0.6-0.2-0.9-0.3c-0.6,0.2-1,0.3-1.4,0.3
            c-0.7-0.1-2-0.1-2.6-0.1c-0.5,0.1-0.9,0-1-0.2c0,0-0.1,0-0.3-0.1c0,0.1,0,0.2,0,0.3C3.1,0.4,2.3,0.3,1.7,0.3C1.3,0.4,1,0.5,0.8,0.6
            C0.5,0.8,0.1,0.9,0,1l1,0.2c0.6,0,1.4,0.1,2.3,0.1c0-0.1,0-0.2,0-0.3c0.2,0,0.3,0.1,0.3,0.1c0.1,0.2,0.5,0.3,1,0.2
            c0.3,0,0.7,0,1.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.5,0,1.1,0,1.4,0.1c0.4,0.1,0.9,0,1.5-0.3c0.3,0.1,0.6,0.3,1,0.3
            c0.7,0,1.4,0,2-0.1c0.6-0.2,1-0.3,1.5,0c0.2,0.1,0.7,0.1,1.3,0.1c-0.1-0.1-0.2-0.2-0.3-0.4c0.4,0.1,0.7,0.1,1,0.1
            c0.7,0.1,1.4,0.2,1.8-0.2c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2c0,0,0,0,0,0
            c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.6,0.1,1,0.3,1.6,0.2c0.5-0.1,1.2-0.1,1.5,0c0.5,0.2,1,0.1,1.4,0
            c0.4-0.1,0.7,0.3,1.2,0.1c0.1,0,0.7,0.1,0.8-0.2c0,0,0.1,0,0.2,0C25,1.2,25,1.2,25,1.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1
            c0,0-0.1,0.1-0.1,0.1c0.2,0,0.4,0,0.5,0c0.4,0.1,0.8,0.3,1.3,0c0,0,0.2,0,0.3,0c0.7,0,0.9,0,1.4-0.1c0.3,0.3,0.7,0.5,1.6,0.4
            c-0.1-0.1-0.1-0.2-0.2-0.3c1.1,0,1.9,0.5,3,0.3c0.1-0.2,0.4-0.3,0.9-0.2c0.3,0.1,0.6,0.1,1,0.1c0.5-0.1,1.1-0.1,1.6,0
            c0.4,0,0.8,0.1,1.2,0c0.5-0.1,1.1-0.1,1.5,0.2c0.6-0.3,0.6-0.3,1.5-0.2c0.4,0.1,0.9,0.1,1.2,0.1c0.4-0.1,0.7-0.3,1.1-0.4
            c0.2,0.2,0.2,0.3,0.4,0.4c0.1,0,0.4,0,0.6,0c0.3,0,0.5-0.1,0.9-0.1c0,0.2,0,0.4-0.1,0.5c0.2,0,0.3,0,0.3-0.1
            c0.3-0.3,0.6-0.5,1.3-0.4c0.4,0,0.8,0.1,1.3,0.1c0.2,0,0.4-0.1,0.6-0.1c0,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1
            c0.2-0.1,0.3-0.2,0.5-0.2c0.3,0,0.5,0,0.7-0.2c0.1-0.2,0.4-0.2,0.7,0c0.6,0.3,1.4,0,2,0.2c0.4-0.3,1-0.2,1.6-0.1c0.3,0,0.6,0,0.8,0
            c0.2,0,0.5,0,0.7,0c0.1-0.1,0.3-0.2,0.5-0.3c0.5,0.1,1,0.2,1.4,0.3c0.3-0.1,0.7-0.2,1.1-0.4c0.2,0.1,0.4,0.2,0.6,0.3
            c0.5,0.1,0.6-0.3,1.1-0.1c0.3,0.1,0.8,0.1,1.2,0.1c0.8-0.1,1.7-0.2,2.7,0c0.7,0.1,1.4,0.1,2.2-0.2c0.1,0.1,0.3,0.2,0.4,0.4
            c0.4-0.2,0.6-0.3,0.8-0.4c0.2,0.1,0.3,0.2,0.4,0.3c0.4-0.1,0.8-0.2,1.3-0.3c0.1,0,0.2,0.1,0.3,0.2c0.3-0.1,0.6-0.1,1-0.2
            c0.2,0.1,0.3,0.2,0.6,0.4c0,0,0,0,0,0c-0.1-0.1-0.1-0.3,0.1-0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,0.7,0.2,1,0.3
            c0.3-0.2,0.4-0.5,1.2-0.3c0.6,0.2,0.9-0.2,1.4-0.2c0.4,0.3,1,0.4,1.8,0.3c0-0.1,0-0.1,0-0.2c0.8-0.1,1.7,0.2,2.5-0.1
            c0.5,0.2,0.9,0.3,1.4,0.5c0.1-0.1,0.3-0.3,0.4-0.4c0.7,0.4,1.6-0.1,2.2,0.3c0.3-0.2,0.5-0.3,0.8-0.5c0.1,0.4,0.2,0.5,1.2,0.2
            c0.5,0.1,1,0.4,1.5,0c0,0,0.4,0,0.7,0c0.5,0.1,0.9,0.2,1.4,0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
            c1.1,0.2,2.1-0.1,3.2-0.1c0.8,0,1.6,0.1,2.5,0c0,0,0.2,0.1,0.3,0.3c0.5-0.2,1-0.4,1.8-0.3c0.1,0,0.4,0,0.5,0
            c0.7-0.3,1.3-0.1,1.8,0.2c0.5-0.2,0.8-0.5,1.5-0.2c0.9-0.1,1.9,0.3,2.8-0.1c0.1,0,0.4,0,0.6,0c1.4,0.2,2.9,0.1,4.3,0.1
            c0.3,0,0.7-0.1,1.1-0.2c0.1,0,0.3,0.2,0.6,0.2c0.3,0,0.6-0.1,1-0.1c0.1,0.1,0.2,0.2,0.3,0.2c0.3-0.1,0.6-0.2,0.8-0.3
            c0.1,0,0.2,0,0.2,0c0.5,0.1,1,0.2,1.6,0.3c0.1-0.2,0.1-0.3,0.2-0.4c0.2,0,0.4,0.1,0.6,0.1c0.5,0.2,1,0.1,1.5,0.1c0.5,0,1,0,1.6,0.1
            c0,0,0.2-0.1,0.3-0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.3,0,0.4-0.1c-0.1,0-0.1-0.1-0.2-0.1c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0
            c0,0,0.1,0,0.1,0.1c-0.2-0.2,0-0.3,0.5-0.4c0,0.1,0.1,0.2,0.1,0.4c-0.2,0-0.4,0-0.6,0c0.6,0.3,1.5,0,2.3,0.1
            c1.1-0.2,2.3-0.1,3.4,0.1c0-0.1,0.1-0.2,0.1-0.3c1.6,0.2,1.6,0.2,2.3,0c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0,0.9-0.1,1.4,0.1
            c0.1,0,0.2,0,0.2,0c0.6-0.3,1.2-0.1,1.8,0c0.2,0,0.5,0,0.7,0c0.3,0,0.6,0,1,0c-0.1-0.3,0.4-0.3,0.9-0.3c0.1,0.1,0.2,0.2,0.3,0.3
            c0.3-0.1,0.5-0.2,0.7-0.4c0.4,0.1,0.8,0.2,1.2,0.3c0.2-0.3,0.7-0.3,1.2-0.2c0.4,0,0.7,0.1,1,0.2c0.5,0.1,0.9,0,1.1-0.2
            c0.3,0,0.6,0.1,1,0.1c0.3,0,0.6-0.1,1-0.1c0.6,0.4,1.5,0.2,2.3,0.1c0.8,0,1.6-0.1,2.5,0c0.4,0.1,1-0.1,1.6-0.1c0,0,0.1,0.1,0.2,0.2
            c0.3-0.1,0.5-0.1,0.7-0.2c0.2,0,0.3-0.1,0.6-0.2c0.2,0.1,0.4,0.2,0.6,0.3c1.1-0.2,2.1-0.2,3,0.2c0.1-0.2,0.2-0.4,0.3-0.6
            c0.3,0.2,0.6,0.3,1.1,0.2c0.8,0,1.6-0.1,2.3,0.1c0.2,0.1,0.6-0.1,1-0.1c0.2,0,0.4,0,0.6,0.1c0,0,0-0.1,0-0.1c0-0.2-0.2-0.4-0.8-0.5
            c-0.2,0-0.4-0.1-0.6-0.1C158.5,0.5,158.3,0.6,158.3,0.6z M6.4,1.1c-0.5,0.1-0.7,0-0.6-0.3C6.1,1,6.2,1.1,6.4,1.1z M9.3,0.7
            c-0.1,0-0.2,0-0.3-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.3,0.1C9.4,0.7,9.4,0.7,9.3,0.7z M13.1,1.1c0,0-0.1,0-0.2,0
            c0-0.1,0-0.1-0.1-0.2c0.1,0,0.2,0,0.3,0C13.2,1,13.2,1,13.1,1.1z M15.9,1c-0.2-0.2-0.2-0.2,0.5-0.2C16.2,0.9,16.1,0.9,15.9,1z
             M26.8,1.3c0,0-0.1,0.1-0.2,0.1c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.2-0.1C26.7,1.3,26.8,1.3,26.8,1.3z M28.2,0.7
            c-0.1,0-0.2-0.1-0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0.1,0.2,0.1,0.3,0.1C28.3,0.7,28.2,0.7,28.2,0.7z M33.3,1.1
            c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.1c0,0,0.1-0.1,0.1-0.1C33.1,1.1,33.1,1.1,33.3,1.1z M71.9,1
            c-0.4,0.1-0.5,0-0.5-0.3C71.7,0.9,71.8,1,71.9,1z M91.8,0.9c0.2-0.2,0.4-0.3,0.9-0.2C92.5,0.8,92.4,1,91.8,0.9z"
            />
            <path fill={color} d="M73.6,2.1c-0.1-0.1-0.2-0.1-0.5-0.3C73.1,2.1,73.2,2.2,73.6,2.1z" />
            <path fill={color} d="M94.3,1.9C94.9,2,95,1.8,95.2,1.7C94.6,1.6,94.4,1.7,94.3,1.9z" />
            <path
                fill={color}
                d="M17,2.3c0.1,0,0.2,0,0.2,0c0-0.1,0-0.1-0.1-0.2c-0.2,0.1-0.3,0.1-0.3,0.1C16.9,2.2,17,2.3,17,2.3z"
            />
            <path fill={color} d="M15.7,2C15.8,2,16,1.9,16.1,1.8C15.5,1.8,15.5,1.8,15.7,2z" />
            <path
                fill={color}
                d="M12.6,2.2c0.1,0,0.2,0,0.2,0c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0C12.5,2,12.6,2.1,12.6,2.2z"
            />
            <path
                fill={color}
                d="M8.5,1.7c0.1,0,0.2,0.1,0.3,0.1C8.9,1.7,9,1.7,9,1.7C9,1.6,8.9,1.6,8.7,1.6C8.7,1.6,8.6,1.6,8.5,1.7z"
            />
            <path
                fill={color}
                d="M28.1,1.6c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1C28.2,1.6,28.1,1.6,28.1,1.6z"
            />
            <path
                fill={color}
                d="M33.2,2.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C33.3,2.1,33.2,2.2,33.2,2.2z"
            />
            <path
                fill={color}
                d="M38.9,2.9c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0,0-0.1-0.1-0.2-0.2C39,2.8,38.9,2.9,38.9,2.9z"
            />
            <path
                fill={color}
                d="M26.7,2.5c0.1,0,0.2-0.1,0.2-0.1c0,0-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.1C26.5,2.4,26.6,2.4,26.7,2.5z"
            />
            <path
                fill={color}
                d="M25.4,2.2c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.1c0,0,0.1,0.1,0.2,0.1C25.3,2.3,25.4,2.2,25.4,2.2z"
            />
            <path
                fill={color}
                d="M28,3c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0.1-0.2,0.1C27.9,3,27.9,3,28,3z"
            />
        </g>
    </svg>
);

LineMedium.propTypes = propTypes;
LineMedium.defaultProps = defaultProps;

export default LineMedium;
